import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import UrlProcessor from '../../components/Url.vue';
export default {
  __name: 'UrlPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "URL图像处理",
        "current-page": "url"
      }, {
        default: _withCtx(() => [_createVNode(UrlProcessor)]),
        _: 1
      });
    };
  }
};